<template>
  <div class="contentBox">
    <div 
      v-for="(img, index) in imgs" 
      :key="index" 
      class="contentBlock fade-in-section"
    >
      <img :src="img" />
    </div>
  </div>
</template>

<script>
import "./index.css";

const IMG_NUM = 6;
const imgs = {};

for (let i = 1; i <= IMG_NUM ; i++) {
  imgs[i] = require(`@/page/cptthanhvancompany/components/img/index${i}.png`);
}

export default {
  data() {
    return {
      imgs,
    };
  },
  mounted() {
    this.InitPage();
  },
  methods: {
    InitPage(){
      window.scrollTo({ top: 0 });
      const fadeInSections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
      });
    }, {
        threshold: 0.3
    });
      fadeInSections.forEach(section => {
          observer.observe(section);
      });
    }
  },
};
</script>

<style scoped>
.contentBox .contentBlock:nth-child(4){
  padding: 40px 160px 40px 160px;
}

.contentBlock {
    min-height: 400px;
}
</style>